import {IHttpService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";

export class LeagueInviteController {

    public emails: Array<any> = [];
    public inviteEmails: Array<string> = [];
    public inviting = false;

    /** @ngInject */
    public constructor(private $http: IHttpService, public league: any, private $uibModalInstance: IModalInstanceService) {

    }

    public updateEmails() {
        this.inviteEmails = this.emails.map((e) => e.text);
    }

    public async sendInvites() {
        this.inviting = true;
        await this.$http.post('/tradefloor/api/leaderboards/' + this.league.name + '/invite', this.inviteEmails);
        this.inviting = false;
        this.$uibModalInstance.close();
    }
}